import cn from 'classnames';
import ethBlackSvg from './eth-black.svg';
import ethWhiteSvg from './eth-white.svg';
import ethSvg from './eth.svg';
import styles from './EthIcon.module.scss';

const ICONS = {
  color: ethSvg,
  black: ethBlackSvg,
  white: ethWhiteSvg,
};

type Props = {
  className?: string;
  size?: 'small' | 'medium' | 'large';
  type?: 'color' | 'black' | 'white';
};
export default function EthIcon({className = '', size = 'small', type = 'color'}: Props) {
  return <img className={cn(className, styles[size])} src={ICONS[type]} alt='ETH' title='ETH' />;
}
